import { Badge, type BadgeProps } from '@/components/ui/badge';
import type { EstimateStatus } from '@/types/estimate';

interface EstimateStatusBadgeProps {
  status: EstimateStatus;
}

const statusConfig: Record<EstimateStatus, { label: string; variant: BadgeProps['variant']; className?: string }> = {
  draft: {
    label: 'Draft',
    variant: 'secondary',
    className: 'bg-muted text-muted-foreground',
  },
  sent: {
    label: 'Sent',
    variant: 'info',
  },
  viewed: {
    label: 'Viewed',
    variant: 'outline',
    className: 'border-transparent bg-chart-2/10 text-chart-2',
  },
  accepted: {
    label: 'Accepted',
    variant: 'success',
  },
  declined: {
    label: 'Declined',
    variant: 'destructive-soft',
  },
  expired: {
    label: 'Expired',
    variant: 'warning',
  },
  cancelled: {
    label: 'Cancelled',
    variant: 'secondary',
    className: 'bg-muted text-muted-foreground line-through decoration-muted-foreground/60',
  },
};

export function EstimateStatusBadge({ status }: EstimateStatusBadgeProps) {
  const config = statusConfig[status] || statusConfig.draft;

  return (
    <Badge variant={config.variant} className={config.className}>
      {config.label}
    </Badge>
  );
}
